import axios from "axios";
import { SET_ALERT } from "../alert";

export const SET_REGISTERS    = "SET_CASH_REGISTERS";
export const SET_REGISTER     = "SET_CASH_REGISTER";
export const SET_LOADING      = "SET_LOADING_CASH_REGISTER";

export default {
  state: {
    registers: [],
    register: null,
    isLoading: false,
  },
  mutations: {
    [SET_LOADING](s, v) { s.isLoading = v; },
    [SET_REGISTERS](s, v) { s.registers = v; },
    [SET_REGISTER](s, v) { s.register = v; },
  },
  actions: {
    getCashRegisters({ commit }, filters) {
      if (filters == undefined) filters = "";
      commit(SET_LOADING, true);
      return axios
        .get("api/cash-registers?" + filters)
        .then((r) => { commit(SET_LOADING, false); commit(SET_REGISTERS, r.data); })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    openCashRegister({ commit }, form) {
      commit(SET_LOADING, true);
      return axios
        .post("api/cash-registers/open", form)
        .then((r) => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Caja abierta correctamente", type: "success" });
          commit(SET_REGISTER, r.data);
          return r.data;
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
          throw e;
        });
    },

    getCurrentCashRegister({ commit }) {
      return axios
        .get("api/cash-registers/current")
        .then((r) => { commit(SET_REGISTER, r.data); return r.data; })
        .catch(() => { commit(SET_REGISTER, null); });
    },

    getCashRegister({ commit }, id) {
      commit(SET_LOADING, true);
      return axios
        .get("api/cash-registers/" + id)
        .then((r) => { commit(SET_LOADING, false); commit(SET_REGISTER, r.data); })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    addCashRegisterTip({ commit }, { id, form }) {
      commit(SET_LOADING, true);
      return axios
        .post("api/cash-registers/" + id + "/tips", form)
        .then((r) => { commit(SET_LOADING, false); return r.data; })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
          throw e;
        });
    },

    deleteCashRegisterTip({ commit }, payload) {
      const tid = payload.tipId || payload;
      return axios
        .delete("api/cash-registers/tips/" + tid)
        .then(() => { commit(SET_ALERT, { message: "Propina eliminada", type: "success" }); })
        .catch((e) => {
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    addCashRegisterExpense({ commit }, { id, form }) {
      commit(SET_LOADING, true);
      return axios
        .post("api/cash-registers/" + id + "/expenses", form)
        .then((r) => { commit(SET_LOADING, false); return r.data; })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
          throw e;
        });
    },

    deleteCashRegisterExpense({ commit }, expenseId) {
      return axios
        .delete("api/cash-registers/expenses/" + expenseId)
        .then(() => { commit(SET_ALERT, { message: "Gasto eliminado", type: "success" }); })
        .catch((e) => {
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    closeCashRegister({ commit }, payload) {
      commit(SET_LOADING, true);
      return axios
        .post("api/cash-registers/" + payload.id + "/close", payload.form)
        .then((r) => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Caja cerrada correctamente", type: "success" });
          commit(SET_REGISTER, r.data);
          return r.data;
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) commit(SET_ALERT, { message: e.response.data.message, type: "error" });
          throw e;
        });
    },
  },
};
